"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnClickPiece = void 0;
const models_1 = require("@creature-chess/models");
const react_redux_1 = require("react-redux");
const ui_1 = require("~/store/game/ui");
const useOnClickPiece = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const store = (0, react_redux_1.useStore)();
    return (pieceId) => {
        const selectedPieceId = store.getState().game.ui.selectedPieceId;
        if (selectedPieceId === null) {
            dispatch(ui_1.UIActions.selectPiece(pieceId));
            return;
        }
        dispatch(models_1.PlayerActions.swapPiecePlayerAction({
            pieceAId: selectedPieceId,
            pieceBId: pieceId,
        }));
        dispatch((0, ui_1.clearSelectedPiece)());
    };
};
exports.useOnClickPiece = useOnClickPiece;
